import {
  type CountryCodeValue,
  MarketCountryCode,
} from '@backmarket/http-api/src/api-models/MarketCountryCode'

const ENABLED_VARIATIONS = ['enabled', 'selectorEnabled']

export function isEsUsLocaleSelectorEnabled(
  experimentValue: string,
  countryCode: CountryCodeValue,
): boolean {
  return (
    countryCode === MarketCountryCode.US &&
    ENABLED_VARIATIONS.includes(experimentValue)
  )
}
